import React from 'react';
import { Grid2, Typography, Tabs, Tab, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { withTransaction } from '@elastic/apm-rum-react';

import AccessLogs from '../../components/Logs/AccessLogs';
import AuditLogs from '../../components/Logs/AuditLogs';
import useLogs from '../../hooks/useLogs';
import useTabChange from '../../components/Common/styled/Tabs';

const Logs = () => {
  const [tabIndex, setTabIndex] = useTabChange(0);
  const orgName = useSelector((state) => state.common.orgName);

  const {
    fetchAccessLogs,
    fetchUserStats,
    accessLogsList,
    accessLogsPageCount,
    totalAccessLogsCount,
    fetchAuditLogs,
    auditLogsList,
    auditLogsPageCount,
    totalAuditLogsCount,
    DownloadLogs,
  } = useLogs();

  return (
    <Grid2 container display="flex" flexDirection="column" key={orgName}>
      <Box
        display="flex"
        flexDirection="column"
        margin="20px"
        overflow="auto"
        mb={2}
      >
        <Box>
          <Typography variant="h3">Logs</Typography>
        </Box>
      </Box>

      <Grid2 size={{ xs: 12 }}>
        <Tabs
          value={tabIndex}
          onChange={setTabIndex}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            justifyContent: 'space-between',
            paddingLeft: '12px',
            flex: 1,
          }}
        >
          <Tab
            label="Audit Logs"
            title="Audit logs"
            sx={{
              color:
                tabIndex === 0 ? 'secondary.contrastText' : 'text.inactiveTab',
            }}
          />
          <Tab
            label="Access Logs"
            title="Access logs"
            sx={{
              color:
                tabIndex === 1 ? 'secondary.contrastText' : 'text.inactiveTab',
            }}
          />
        </Tabs>

        {tabIndex === 0 && (
          <Box px={2} py={1}>
            <AuditLogs
              orgName={orgName}
              fetchAuditLogs={fetchAuditLogs}
              auditLogsList={auditLogsList}
              auditLogsPageCount={auditLogsPageCount}
              totalAuditLogsCount={totalAuditLogsCount}
              DownloadLogs={DownloadLogs}
            />
          </Box>
        )}
        {tabIndex === 1 && (
          <Box px={2} py={1}>
            <AccessLogs
              orgName={orgName}
              fetchAccessLogs={fetchAccessLogs}
              fetchUserStats={fetchUserStats}
              accessLogsList={accessLogsList}
              accessLogsPageCount={accessLogsPageCount}
              totalAccessLogsCount={totalAccessLogsCount}
              DownloadLogs={DownloadLogs}
            />
          </Box>
        )}
      </Grid2>
    </Grid2>
  );
};

export default withTransaction('Logs', 'component')(Logs);
